import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import SideEditor from '../../general/SideEditor';
import { fetchBrands, setEditedEntity, confirmDelete } from '../../../actions';
import { getCurrentRestaurant, getCurrentChain } from '../../../selectors';
import BrandEditor from './BrandEditor';
import { DataGrid } from '../../common';

class Brands extends Component {
    componentDidMount() {
        const { id: restId } = this.props.restaurant || {};
        const { id: chainId } = this.props.chain || {};

        this.props.fetchBrands(restId, chainId);
    }

    renderCreationButton = () => {
        let chainId;
        if (this.props.chain) {
            chainId = this.props.chain.id;
        } else if (this.props.restaurant) {
            chainId = this.props.restaurant.ownerId;
        }

        if (chainId) {
            return (
                <Button
                    icon
                    labelPosition="left"
                    primary
                    onClick={() => this.props.setEditedEntity('brand', { chainId })}
                >
                    <Icon name="add" /> {i18next.t('create')}
                </Button>
            );
        }
    }

    render() {
        const { onEdit, brands, setEditedEntity, history } = this.props;

        const columns = [{
            Header: i18next.t('brands.brandKey'),
            maxWidth: 200,
            accessor: 'key',
            filterable: true
        }, {
            Header: i18next.t('brands.platform'),
            accessor: 'platform',
            filterable: true
        }, {
            id: 'actions',
            Header: i18next.t('actions'),
            minWidth: 142,
            maxWidth: 142,
            sortable: false,
            filterable: false,
            Cell: row => {
                const brand = row.original;

                return (
                    <div>
                        <Button
                            circular
                            size='tiny'
                            icon='write'
                            basic
                            onClick={() => {
                                let path = `/brands/${brand.key}`;

                                if (this.props.restaurant) {
                                    history.push(`/restaurant/${this.props.restaurant.id}${path}`);
                                } else if (this.props.chain) {
                                    history.push(`/chain/${this.props.chain.id}/marketing${path}`);
                                } else {
                                    history.push('/');
                                }
                            }}
                        />
                    </div>
                );
            }
        }];

        return (
            <div style={{ padding: 10 }}>
                {<SideEditor
                    title={i18next.t('brands.brand')}
                    visible={onEdit}
                    handleClose={() => setEditedEntity(null)}
                >
                    <BrandEditor />
                </SideEditor>}

                <DataGrid
                    data={brands}
                    columns={columns}
                    extraActions={this.renderCreationButton()}
                    paginated
                   
                />
            </div>
        );
    }
}

Brands.propTypes = {
    onEdit: PropTypes.bool,
    setEditedEntity: PropTypes.func,
    fetchBrands: PropTypes.func,
    brands: PropTypes.array,
    restaurant: PropTypes.object,
    chain: PropTypes.object,
    
    history: PropTypes.object,
};

const mapStateToProps = (state) => {
    const onEdit = state.editor.type === 'brand';
    const { brands } = state.businessApp;
    const restaurant = getCurrentRestaurant(state);
    const chain = getCurrentChain(state);

    return { onEdit, brands, restaurant, chain };
};

export default connect(mapStateToProps, { fetchBrands, setEditedEntity, confirmDelete })(Brands);
